import { route } from "../../service/routeDictionary";
import API from "../../service/api";
import { environment } from "../../environments/env";

const state = {
  hasFileLarge: false,
  baseImg:
    localStorage.getItem("baseImg") != null
      ? JSON.parse(localStorage.getItem("baseImg"))
      : "foiewjoifjiew",
};

const getters = {
  baseImg: (state) => state.baseImg,
  fileLarge: (state) => state.hasFileLarge,
};

const actions = {
  async getLibraryByPagination({ commit }, data) {
    if (data.name.length > 0) {
      return await API.get(
        `${environment.apiUri}${route.InstagramLibraryUpload}?&Owner=${data.name}&Offset=${data.offset}&sort=-timestamp`
      );
    } else {
      return await API.get(
        `${environment.apiUri}${route.InstagramLibraryUpload}?limit=${data.limit}&Offset=${data.offset}&sort=-timestamp`
      );
    }
  },

  async getLibrary({ commit }, data) {
    return await API.get(
      `${environment.apiUri}${route.InstagramLibraryUpload}`,
      data
    );
  },

  async UploadFile({ commit }, data) {
    return await API.post(
      `${environment.apiUri}${route.UploadFile}?MktNaLoja=true`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  },

  async PostLibrary({ commit }, data) {
    return await API.post(
      `${environment.apiUri}${route.InstagramLibraryUpload}`,
      data
    );
  },

  async PutLibrary({ commit }, data) {
    return await API.put(
      `${environment.apiUri}${route.InstagramLibraryUpload}?Id=${data.id}&InstagramLibraryCategoryId=${data.instagramLibraryCategoryId}`,
      data
    );
  },

  async DeleteLibrary({ commit }, data) {
    return await API.delete(
      `${environment.apiUri}${route.InstagramLibraryUpload}?InstagramLibraryMediaId=${data.id}`
    );
  },

  async getcategory() {
    return await API.get(
      `${environment.apiUri}${route.InstagramLibraryCategory}`
    );
  },

  async setBaseImg({ commit }, data) {
    commit("set_Base_Img", data);
  },

  setFile({ commit }, data) {
    commit("set_hasFileLarge", data);
  },
};

const mutations = {
  async set_Base_Img(state, data) {
    localStorage.setItem("guilherme", JSON.stringify(data));
    state.baseImg = data;
  },

  set_hasFileLarge(state, data) {
    state.hasFileLarge = data;
  },
};

export default {
  state,
  actions,
  getters,
  mutations,
};
